module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.0-rc.49-69.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.1.0-rc.49.md
// module id = 488
// module chunks = 366